import React from 'react';
import PropTypes from 'prop-types';
import DefaultSelectV2 from '../DefaultSelectV2';

const TipoEquipamentoSelectV2 = ({ error, onChange, value, disabled, isRequired, showEmpty }) => (
  <DefaultSelectV2
    error={error} showEmpty={showEmpty} isRequired={isRequired}
    label="Tipo Equipamento" name="tipoEquipamento"
    onSelect={e => onChange(e.target.value ? e.target.value : null)}
    options={[
      { id: 'ALICATE_HIDRAULICO', descricao: 'Alicate Hidráulico' },
      { id: 'CAMERA_FOTOGRAFICA', descricao: 'Câmera Fotográfica' },
      { id: 'CELULAR', descricao: 'Celular' },
      { id: 'CHIP', descricao: 'Chip' },
      { id: 'DRONE', descricao: 'Drone' },
      { id: 'GPS', descricao: 'GPS' },
      { id: 'IPAD', descricao: 'iPad' },
      { id: 'MONITOR', descricao: 'Monitor' },
      { id: 'NOTEBOOK', descricao: 'Notebook' },
      { id: 'RADIO', descricao: 'Rádio' },
      { id: 'TERMOVISOR', descricao: 'Termovisor' },
    ]}
    value={value}
    handlerOption={option => option.descricao}
    disabled={disabled}
  />
);

TipoEquipamentoSelectV2.propTypes = {
  error: PropTypes.bool, onChange: PropTypes.func, value: PropTypes.string,
  disabled: PropTypes.bool, isRequired: PropTypes.any, showEmpty: PropTypes.bool
};
TipoEquipamentoSelectV2.defaultProps = { value: '', showEmpty: false, onChange: () => {} };
export default TipoEquipamentoSelectV2;
